import React from 'react';
import { Layout, Menu, Typography, Space, Button } from 'antd';
import { useNavigate, useLocation } from 'react-router-dom';
import {
  DashboardOutlined,
  ExperimentOutlined,
  DatabaseOutlined,
  MessageOutlined,
  FileTextOutlined,
  SettingOutlined,
  UserOutlined
} from '@ant-design/icons';

const { Header, Content, Sider } = Layout;
const { Title } = Typography;

interface MainLayoutProps {
  children: React.ReactNode;
}

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const menuItems = [
    {
      key: '/dashboard',
      icon: <DashboardOutlined />,
      label: 'Dashboard',
    },
    {
      key: '/study-builder',
      icon: <ExperimentOutlined />,
      label: 'Study Builder',
    },
    {
      key: 'workbench',
      icon: <SettingOutlined />,
      label: 'Workbench',
      children: [
        {
          key: '/metadata-explorer',
          icon: <DatabaseOutlined />,
          label: 'Metadata Explorer',
        },
        {
          key: '/insight-console',
          icon: <MessageOutlined />,
          label: 'Insight Console',
        },
        {
          key: '/insight-generator',
          icon: <FileTextOutlined />,
          label: 'Insight Generator',
        },
      ],
    },
  ];

  const handleMenuClick = (key: string) => {
    navigate(key);
  };

  // Get current selected key based on path
  const getCurrentKey = () => {
    const path = location.pathname;
    if (path.includes('/metadata-explorer')) return '/metadata-explorer';
    if (path.includes('/insight-console')) return '/insight-console';
    if (path.includes('/insight-generator')) return '/insight-generator';
    if (path.includes('/study-builder')) return '/study-builder';
    return path;
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      <Header style={{ 
        background: '#fff', 
        padding: '0 24px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
        position: 'sticky',
        top: 0,
        zIndex: 1000,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        <Space align="center">
          <div style={{
            width: 32,
            height: 32,
            background: 'linear-gradient(135deg, #722ed1 0%, #9254de 100%)',
            borderRadius: 6,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            color: 'white',
            fontWeight: 'bold',
            fontSize: 16
          }}>
            R
          </div>
          <Title level={3} style={{ margin: 0, color: '#722ed1' }}>
            NRG Refract
          </Title>
        </Space>
        
        <Space>
          <Button 
            type="text" 
            icon={<UserOutlined />}
            style={{ border: '1px solid #d9d9d9' }}
          >
            Profile
          </Button>
        </Space>
      </Header>

      <Layout>
        <Sider 
          width={240} 
          style={{ 
            background: '#fff',
            borderRight: '1px solid #f0f0f0'
          }}
        >
          <Menu
            mode="inline"
            selectedKeys={[getCurrentKey()]}
            defaultOpenKeys={['workbench']}
            style={{ height: '100%', borderRight: 0 }}
            items={menuItems}
            onClick={({ key }) => handleMenuClick(key)}
          />
        </Sider>

        <Layout>
          <Content style={{ 
            padding: '24px',
            background: '#f5f5f5',
            minHeight: 'calc(100vh - 64px)'
          }}>
            {children}
          </Content>
        </Layout>
      </Layout>
    </Layout>
  );
};

export default MainLayout; 